import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { addTeacher } from "../services/teacherService.js";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/StudentSubscriptionForm.css";

const TeacherSubscriptionForm = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const redirectTo = location.state?.redirectTo || '/';
  const intent = location.state?.intent || null;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    setError("");
    if (!formData.name || !formData.email || !formData.password) {
      setError(t("studentSubscription.errors.requiredFields", "Please fill in all required fields."));
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      setError(t("studentSubscription.errors.invalidEmail", "Invalid email format."));
      return false;
    }
    if (formData.password !== formData.confirmPassword) {
      setError(t("studentSubscription.errors.passwordMismatch", "Passwords do not match."));
      return false;
    }
    if (formData.password.length < 6) {
      setError(t("studentSubscription.errors.weakPassword", "Password must be at least 6 characters long."));
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    setError("");
    setSuccess(false);

    try {
      const teacherData = {
        name: formData.name,
        email: formData.email,
        password: formData.password,
      };
      await addTeacher(teacherData);
      setSuccess(true);

      // Após cadastro, voltar ao login preservando redirect/intent
      setTimeout(() => {
        navigate('/login', { state: { redirectTo, intent }, replace: true });
      }, 800);
    } catch (error) {
      console.error("Error adding teacher:", error);
      setError(error.message || t("teacherSubscription.errors.generalError", "An error occurred during signup. Please try again."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="student-subscription-container">
      <h2>{t("teacherSubscription.title", "Teacher Registration")}</h2>

      {success && (
        <div className="success-message">
          {t("teacherSubscription.successMessage", "Registration successful! You can now log in.")}
        </div>
      )}

      {error && <div className="error-message">{error}</div>}

      <form onSubmit={handleSubmit} className="student-subscription-form">
        <div className="form-group">
          <label htmlFor="name">{t("teacherSubscription.form.name", "Full Name")} *</label>
          <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required aria-required="true" />
        </div>

        <div className="form-group">
          <label htmlFor="email">{t("teacherSubscription.form.email", "Email Address")} *</label>
          <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required aria-required="true" />
        </div>

        <div className="form-group">
          <label htmlFor="password">{t("teacherSubscription.form.password", "Password")} *</label>
          <input type="password" id="password" name="password" value={formData.password} onChange={handleChange} required aria-required="true" minLength="6" />
        </div>

        <div className="form-group">
          <label htmlFor="confirmPassword">{t("teacherSubscription.form.confirmPassword", "Confirm Password")} *</label>
          <input type="password" id="confirmPassword" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} required aria-required="true" minLength="6" />
        </div>

        <button type="submit" className="submit-button" disabled={loading}>
          {loading
            ? t("teacherSubscription.form.submitting", "Registering...")
            : t("teacherSubscription.form.submit", "Register Teacher")}
        </button>
      </form>
    </div>
  );
};

export default TeacherSubscriptionForm;
